import { useContext, useEffect, useState } from "react";
import { Button, Dropdown, Input } from "semantic-ui-react";
import { ProductContext } from "../context/productContext";
import AccordionItem from "./AccordionItem";
import api from "../context/api";
import { openMessage, askMessage } from "../Modal";

function VariantPage() {
  const { getProductVariantOptions, getProductVariantProducts } =
    useContext(ProductContext);
  const [variantOptions, setVariantOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);

  useEffect(async () => {
    setVariantOptions([...(await getProductVariantOptions())]);
    setProductOptions(convertToLabel(await getProductVariantProducts()));
  }, []);

  const convertToLabel = (ps) => {
    return ps.map((p) => {
      return {
        text: p.name,
        key: p.id,
        value: p.id,
        image: { avatar: true, src: p.thumbnailFileUrl },
      };
    });
  };

  const handleAddProduct = (i, products) => {
    setVariantOptions(
      variantOptions.map((pvo, vi) => {
        if (i == vi) {
          return { ...pvo, products: products };
        }
        return pvo;
      })
    );
  };

  const handleChangeName = (i, name) => {
    setVariantOptions(
      variantOptions.map((pvo, vi) => {
        if (i == vi) {
          return { ...pvo, name: name };
        }
        return pvo;
      })
    );
  };

  const handleAddVariant = () => {
    setVariantOptions([...variantOptions, { name: "", products: [] }]);
  };

  const handleDeleteVariant = (index) => {
    if (!variantOptions[index].id || variantOptions[index].id == 0) {
      setVariantOptions(
        variantOptions.filter((vo, iii) => {
          return iii != index;
        })
      );
      return;
    }
    askMessage(
      "Variant Silinecektir...",
      async () => {
        console.log("variantOptions", variantOptions);
        await api.deleteProductVariant(variantOptions[index].id);
        setVariantOptions([...(await getProductVariantOptions(true))]);
        openMessage("Variant Silindi...", true);
      },
      () => {}
    );
  };

  const handleSaveProductVariants = async (index) => {
    openMessage("Variant Kaydediliyor...");
    try {
      await api.saveProductVariant(variantOptions[index]);
      setVariantOptions([...(await getProductVariantOptions(true))]);
      openMessage("Variant Kaydedildi...", true);
    } catch (e) {
      openMessage("Variant Kaydedilirken hata oluştu...", true);
    }
  };

  return (
    <AccordionItem header="Variant" key={"variant-root-accordion"}>
      <div
        key={"variant-root"}
        style={{
          color: "#FFF",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        {variantOptions.map((pvo, i) => {
          return (
            <div key={i} className="panel-group">
              <div
                key={"variant-option-product-key-" + i}
                style={{
                  flexGrow: "1",
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                }}
              >
                <Input
                  key={"name_" + i}
                  type="input"
                  id={"name_" + pvo.id}
                  value={pvo.name}
                  style={{ width: "100%" }}
                  onChange={(e, o) => {
                    handleChangeName(i, o.value);
                  }}
                />
                <Dropdown
                  id={"dd_" + i}
                  key={"dd_" + i}
                  options={productOptions}
                  placeholder="Select Product"
                  fluid
                  floating
                  selection
                  search
                  onChange={(e, o) => {
                    handleAddProduct(i, o.value);
                  }}
                  value={pvo.products}
                  multiple
                ></Dropdown>
              </div>
              <div
                key={"variant-option-action-key-" + i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  className="panel-button"
                  key={"variant-option-delete-key-" + i}
                  color="red"
                  onClick={(e) => {
                    handleDeleteVariant(i);
                  }}
                >
                  x
                </Button>
                <Button
                  className="panel-button"
                  key={"variant-option-save-key-" + i}
                  positive
                  onClick={(e) => {
                    handleSaveProductVariants(i);
                  }}
                >
                  {" "}
                  o
                </Button>
              </div>
            </div>
          );
        })}
        <div
          key={"variant-action-panel"}
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="panel-group"
        >
          <Button color="blue" onClick={handleAddVariant}>
            +
          </Button>
        </div>
      </div>
    </AccordionItem>
  );
}

export default VariantPage;
